import type { PredictParams } from './predictParams';

// The estimate page works without them, so a failure here just means an unseeded comparison set.
export async function fetchSelectedAdIds(url: string, params: PredictParams): Promise<number[]> {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params),
            signal: AbortSignal.timeout(4000),
        });

        if (!response.ok) return [];

        const body = await response.json();
        return Array.isArray(body?.selectedAdIds) ? body.selectedAdIds : [];
    } catch {
        return [];
    }
}
